export default __webpack_public_path__ + "static/media/orange-blob.bf468b6a.svg";